import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";
import type { FiltersRoutingParams } from "app/pages/sales-intelligence/modules/leads-search/types/routing";

import {
    setFilterMode,
    setIsFiltersCategoriesPanelExpanded,
    setSelectedFilterCategory,
} from "../store/action-creators";

export const useInitialFilterCategoryFromRoute = (): void => {
    const dispatch = useDispatch();
    const { params } = useCurrentStateAndParams<FiltersRoutingParams>();

    useMount(() => {
        if (params.filtersCategory) {
            dispatch(setSelectedFilterCategory(params.filtersCategory));
            dispatch(setIsFiltersCategoriesPanelExpanded(true));
            dispatch(setFilterMode("filters-list"));
        }
    });
};
